import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { Page404Component } from './components/page404/page404.component';

const routes: Routes = [
  {
    path: 'auth',
    loadChildren: 'app/modules/auth/auth.module#AuthModule'
  },
  {
    path: 'app',
    loadChildren: 'app/modules/pages/pages.module#PagesModule'
  },
  {
    path: '',
    redirectTo: 'auth',
    pathMatch: 'full'
  },
  {
    path        : '**',
    pathMatch   : 'full',
    component   : Page404Component
  }
];

export const AppRoutingModule: ModuleWithProviders = RouterModule.forRoot(routes);
